// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2242":"e787bd28525fb645","4837":"6660e5184d68429b","7800":"90f57573fb44f64b"}[chunkId] + ".js";
};